export default __webpack_public_path__ + "landlord.zh-cn.1762841572775.json";